import { useLingui } from '@lingui/react/macro';
import { formatNumber } from '@/features/report-snapshots/formatters/number';
import { formatTimestamp } from '@/features/report-snapshots/formatters/timestamp';
import type { TimeInterval, Timezone } from '@/features/report-snapshots/api/schema';
import { FractionType, PrimitiveType } from '@/features/report-snapshots/interfaces';
import { formatValue } from '@/features/report-snapshots/formatters/main';

type TimeStamp = number;

/**
 * Hook that returns all formatters with i18n already bound.
 * For use with Highcharts formatter callbacks.
 */
export function useFormatters() {
  const { i18n } = useLingui();
  const numberFormatter = formatNumber(i18n);

  return {
    timestamp: (interval: TimeInterval, value: TimeStamp, timezone: Timezone): string =>
      formatTimestamp(interval, value, timezone, i18n),
    valueFormatters: (value: PrimitiveType | FractionType, conversationUnit: string): string => {
      switch (conversationUnit) {
        case 'value': {
          const primitive = value as number;
          return numberFormatter(primitive);
        }
        default: {
          return formatValue(value, conversationUnit);
        }
      }
    },
  };
}
